<div class="breadcrumbs-wrapper">
    <ul class="breadcrumbs-list">
        <li class="breadcrumbs-list__item return ">
            <span>
                <a [href]="links.backLink">Declaración de Renta {{ vigencia }}</a>
            </span>
        </li>
        <li class="breadcrumbs-list__item current">
            <span>
                Consulta renta
            </span>
        </li>
    </ul>
</div>
